// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"PrivacyAndTermsModal_modalBackdrop__W0K9M","modalContent":"PrivacyAndTermsModal_modalContent__80tSq","ol_reset":"PrivacyAndTermsModal_ol_reset__L8Yo6"};